import React from "react";
import cookie from '../../assets/images/cookies.svg';
import ButtonPrimary from "../ButtonPrimary";
import { Container, Content } from "./styles";


export default function Cookies() {
  return (
    <>
      <Container>
        <img src={cookie} alt={"Cookies"} title={"Cookies"} />
        <Content>
          <p className="texto-desktop">
            Durante sua navegação, podemos utilizar cookies para: confirmar sua identidade; personalizar seu acesso;
            e acompanhar a utilização de nossos websites, visando o aprimoramento de sua funcionalidade. Alguns cookies são essenciais para nossos serviços, outros opcionais. Você poderá gerenciar os cookies que utilizamos de acordo com suas preferências.
          </p>
          <p className="texto-mobile">Ao navegar por este site você aceita o uso de cookies para agilizar a sua experiência de compra.</p>
          <a href="/termos">Gerenciar cookies.</a>
        </Content>

        <ButtonPrimary text="Aceitar todos cookies" onClick={() => {
          localStorage.setItem("@ConexaoGAM:Cookies", true);
          window.location.reload()
        }} />
      </Container>
    </>
  );
}
